import { useLocation } from 'react-router-dom';
import ClioChat from '../components/ClioChat';

export default function ProductionAssistant() {
  const location = useLocation();
  const isHelpMode = location.state?.helpMode === true;
  return <ClioChat mode="page" initialHelpMode={isHelpMode} sessionKey="helicon_chat_page" />;
}
